const r = (e) => typeof e == "number" ? e : parseFloat(e);
export {
  r as getNumericValue
};
